export const APP_NAME = 'briefs_lobby_perseus';
export const PAGE_NAME = 'briefs_lobby';
export const BRIEFS_LIST_PAGE_SIZE = 10;
